import React, { Component } from "react";
import PropTypes from "prop-types";
import { Col, Layout, Menu, Progress, Row, Icon, Button as B } from "antd";
import { Route, Switch, withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import messages from "./messages";
import Flexbox from "flexbox-react";
import { Link } from "react-scroll";
import { Link as DLink } from "react-router-dom";
import { connect } from "react-redux";
import { pages } from "./../Landing/Landing";
import Button from "./../Button";
import logo from "./../../assets/images/logo.svg";
import SwitchLanguageButton from "./../LangSwitcher";

const Header = Layout.Header;

const P = (props) => {
    const { percent } = props;
    return (
        <Progress
            style={{ lineHeight: 0, height: "4px" }}
            percent={percent || 5}
            status="active"
            showInfo={false}
        />
    );
};

class HomeHeader extends Component{
   
    render() {
        const { formatMessage } = this.props;
        return (
            <Header className="headerLayout">
                <Row
                    type="flex"
                    justify="space-between"
                    className="Header"
                >
                    <Col span={2}><Link to="#home"><img alt={"logo"} className="logo" src={logo}/></Link></Col>
                    <Col xs={0} sm={0} md={0} lg={17}>
                        <Menu mode="horizontal">
                            {Object.keys(pages).filter(p => pages[p].visible).map(
                                p => <Menu.Item key={p}><Link
                                    offset={-64}
                                    to={p}>{formatMessage(pages[p].title)}</Link>
                                </Menu.Item>)}
                        </Menu>
                    </Col>
                    <Col xs={{ offset: 11, span: 2 }} sm={{ offset: 15, span: 2 }} md={{ offset: 16, span: 3 }}
                         lg={{ offset: 0, span: 3 }}>
                        <Flexbox justifyContent="center">
                            <DLink to="/survey">
                                <Button type="primary" >
                                    {formatMessage(messages.button)}
                                </Button>
                            </DLink>
                        </Flexbox>
                    </Col>
                    <Col xs={2} sm={2} md={2} lg={0} style={{ alignItems: "center", top: 4 }}>
                        <B style={{ width: 32, padding: 0, marginTop: 1, fontSize: 22, color: "white" }} ghost={true}
                           onClick={() => this.context.siderToggled()}>
                            <Icon type="bars"/>
                        </B>
                    </Col>
                    <Col xs={0} sm={0} md={0} lg={2} className="lang">
                        <SwitchLanguageButton/>
                    </Col>
                </Row>
            </Header>
        );
    }
}

HomeHeader.contextTypes = {
    siderToggled: PropTypes.func,
};

class H extends Component{
    render() {
        const { steps, currentStep = 1, surveyPassed, intl: { formatMessage } } = this.props;
        return (
            <Switch>
                <Route exact strict path="/survey/edit" component={null}/>
                <Route exact strict path="/survey/result" component={null}/>
                <Route exact strict path="/survey/finish" component={null}/>
                <Route exact strict path="/survey/:status">
                    <P percent={currentStep / steps.length * 100}/>
                </Route>
                <Route exact path="/"
                       render={() => (<HomeHeader surveyPassed={surveyPassed} formatMessage={formatMessage}/>)}/>
                <Route path="*" component={null}/>
            </Switch>
        );
    }
}

const mapStateToProps = ({ survey: { steps = [], currentStep = -1 }, user: { surveyPassed } }) => {
    return {
        steps, currentStep, surveyPassed
    };
};

export default withRouter(injectIntl(connect(mapStateToProps)(H)));





// WEBPACK FOOTER //
// ./src/components/Header/Header.js